import { Grid, Card, Paper, Typography, Box, Divider, Accordion, AccordionSummary, AccordionDetails, Tooltip } from "@mui/material"
import { Header, HeaderActionType, LoadingWrapper } from "ui"
import usePersonStore from "../store/personStore"
import { DispositionTable, CompanyActionHistoryTable, SessionAgeSort, ImportantQuestionTable, TopFlagTable } from "./components/StudentStatCompnents"
import { useQuery } from "@apollo/client"
import { GET_COMPANY_STUDENTS } from "../../features/graphql/query"
import { useEffect, useState } from "react"
import { CompanyActionHistory, CompanySessionStats, CompanyStudentAgeFlags, CompanyTopFlag, RankingItemDto } from "../../__generated__/graphql"
import { AgeMarkerGraph } from "./components/StudentStatCompnents/AgeMarkerGraph"
import { Help, Person, QuestionMark, ToggleOff, ToggleOn } from "@mui/icons-material"
import CommonThemes from "./components/StudentStatCompnents/CommonThemes"
import GenericChip from "../DashboardPages/components/InfoChips/GenericChip"
import { BarChart, PieChart } from "@mui/x-charts"
export type basicStudentInfo = { __typename: string | undefined, id: string, dob: string }
function mapDataToState(data: any) {
    if (data) {

        return {
            ...data,
            aceFlags: data.companyTopFlags.filter((e: any) => e.flagTitle == "ACE")[0]?.rankings,
            pceFlags: data.companyTopFlags.filter((e: any) => e.flagTitle == "PCE")[0]?.rankings,
            riskFlags: data.companyTopFlags.filter((e: any) => e.flagTitle == "Risk")[0]?.rankings,
            protectiveFlags: data.companyTopFlags.filter((e: any) => e.flagTitle == "Protective")[0]?.rankings
        }

    }

}
const CompanyStudentStats = ({ onBack }: { onBack: () => void }) => {
    const companyName = usePersonStore(state => state.company.name)
    const [languageSet, setLanguageSet] = useState("English")
    const [companyInfo, setCompanyInfo] = useState<{
        companyActionHistory: CompanyActionHistory | null,
        sessionStats: CompanySessionStats | null,
        students: basicStudentInfo[],
        pceFlags: RankingItemDto[],
        aceFlags: RankingItemDto[],
        riskFlags: RankingItemDto[],
        protectiveFlags: RankingItemDto[]
        companyStudentAgeFlags: CompanyStudentAgeFlags[]
    }>({
        companyActionHistory: null, sessionStats: null, students: [],
        aceFlags: [], pceFlags: [], riskFlags: [], protectiveFlags: [], companyStudentAgeFlags: []
    })

    const companyId = usePersonStore(state => state.company.id)
    const { loading, data } = useQuery(GET_COMPANY_STUDENTS, {
        variables: { id: companyId }
    })
    useEffect(() => {
        if (data) {
            const companyData = mapDataToState(data?.company);
            setCompanyInfo(companyData)
        }
    }, [loading])

    const switchLanguages = () => {
        if (languageSet == "English") {
            setLanguageSet("Spanish")
        } else {
            setLanguageSet("English")
        }
    }

    const headerActions: HeaderActionType[] = [
        {
            name: languageSet == "English" ? "Spanish Question Statistics" : "English Question Statistics",
            icon: languageSet == "English" ? <ToggleOff color="disabled" /> : <ToggleOn />,
            action: switchLanguages,
            // isHidden: !company.subscriptions.some(e => e.name?.includes("_ES")) //hide the toggle if its spanish
        }
    ]

    // const ageDistribution = Array.from({ length: 12 }, (_, i) => i + 6)
    //     .reduce<Record<string, number>>((acc, age) => {
    //         acc[age.toString()] = 0;
    //         return acc;
    //     }, { "18+": 0 });

    // companyInfo.students.forEach(student => {

    //     const dob = new Date(student.dob);
    //     const today = new Date();

    //     let age = today.getFullYear() - dob.getFullYear();

    //     if (
    //         today.getMonth() < dob.getMonth() ||
    //         (
    //             today.getMonth() === dob.getMonth() &&
    //             today.getDate() < dob.getDate()
    //         )
    //     ) {
    //         age--;
    //     }

    //     if (age < 6) return;

    //     if (age >= 18) {
    //         ageDistribution["18+"]++;
    //     }
    //     else {
    //         ageDistribution[age.toString()]++;
    //     }
    // });
    const ageDistribution = companyInfo.students.reduce<Record<string, number>>(
        (acc, student) => {
            const dob = new Date(student.dob);
            const today = new Date();

            let age = today.getFullYear() - dob.getFullYear();

            if (
                today.getMonth() < dob.getMonth() ||
                (
                    today.getMonth() === dob.getMonth() &&
                    today.getDate() < dob.getDate()
                )
            ) {
                age--;
            }

            if (age < 6) return acc;

            const ageKey = age >= 18 ? "18+" : age.toString();

            acc[ageKey] = (acc[ageKey] ?? 0) + 1;

            return acc;
        },
        {}
    );

    // const ages = Object.keys(ageDistribution);
    // const counts = ages.map(age => ageDistribution[age]);
    const ages = Object.keys(ageDistribution);

    const counts = ages.map(age => ageDistribution[age]);
    return (
        <LoadingWrapper loading={loading}>
            <Card elevation={4} style={{ width: "100%", display: "flex", padding: "16px", height: "auto" }}>
                <Grid container spacing={2}>
                    <Grid size={12} data-tour="student-insights-header">
                        <Header title={`Children Insights`} subtitle={`@${companyName}`} onBack={onBack}
                        />
                    </Grid>
                    <Grid size={12}>
                        <Grid container spacing={2} sx={{ alignItems: "center", justifyContent: "space-between" }}>
                            {/* <Grid size={{ md: 12, lg: 3 }}>
                                <GenericChip
                                    title="All Students"
                                    subtitle={`${companyInfo.students.length}`}
                                    icon={<Person sx={{ fontSize: "56px", color: "secondary" }} />}
                                />
                            </Grid> */}
                            <Grid size={{ md: 12, lg: 6 }}>
                                <Box sx={{ display: "flex", alignContent: "center", flexDirection: "column", textAlign: "center" }}>
                                    <Typography sx={{ display: "flex", alignItems: "center", justifyContent: "center" }} variant="h5">Student Ages
                                        <Tooltip title="Ages are based on the students current age">
                                            <Help fontSize="small" sx={{ paddingLeft: "5px", color: "gray" }} />
                                        </Tooltip>
                                    </Typography>
                                    <Typography>Total: {companyInfo.students.length}</Typography>
                                </Box>

                                <Box component={"div"} sx={{ padding: ".5rem" }}>

                                    <PieChart
                                        series={[
                                            {
                                                data: ages.map((age, index) => ({
                                                    id: age,
                                                    value: counts[index],
                                                    label: String(age),
                                                })),
                                            },
                                        ]}
                                        title="Student Ages"
                                        // hideLegend
                                        height={250}
                                        slotProps={{
                                            legend: {
                                                // direction: "horizontal",
                                                // position: {
                                                //     vertical: "middle",
                                                //     horizontal: "center"
                                                // },
                                                direction: "vertical",
                                                position: {
                                                    vertical: "middle",
                                                    horizontal: "center"
                                                },
                                                sx: {
                                                    maxWidth: "100%",
                                                    flexWrap: "wrap"
                                                }
                                                // padding: 0,
                                            },
                                        }}
                                    />

                                    {/* <BarChart xAxis={[
                                        {
                                            scaleType: "band",
                                            data: ages.map(String),
                                            label: "Age",
                                        },
                                    ]}
                                        series={[
                                            {
                                                data: counts,
                                                label: "Students",
                                            },
                                        ]}
                                        yAxis={[
                                            {
                                                label: "Number of Students",
                                                min: 0,
                                                tickMinStep: 1,
                                            },
                                        ]}
                                        height={250} /> */}
                                </Box>
                            </Grid>
                            <Grid size={{ md: 12, lg: 6 }}>
                                <Paper variant="outlined">
                                    <DispositionTable dispositionCount={companyInfo.sessionStats} />
                                </Paper>
                            </Grid>
                            {/* <Grid size={{ md: 12, lg: 4 }}>
                                <Paper component="div" variant="outlined">
                                    <SessionAgeSort students={companyInfo.students} />
                                </Paper>
                            </Grid> */}
                        </Grid>

                    </Grid>
                    <Grid size={12}>
                        <Grid container spacing={1}>
                            <Grid size={6}>
                                <Paper sx={{ width: "100%" }} component="div" variant="outlined">
                                    <TopFlagTable flags={companyInfo.pceFlags} title={"Positive Childhood Experiences"} />
                                </Paper>
                            </Grid>
                            <Grid size={6}>
                                <Paper sx={{ width: "100%" }} component="div" variant="outlined">
                                    <TopFlagTable flags={companyInfo.aceFlags} title="Adverse Childhood Experiences" />
                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid size={12}>
                        <Grid container spacing={2}>
                            <Grid size={6}>
                                <Paper sx={{ width: "100%" }} component="div" variant="outlined">
                                    <TopFlagTable flags={companyInfo.protectiveFlags} title={"Protective Factors"} />
                                </Paper>
                            </Grid>
                            <Grid size={6}>
                                <Paper sx={{ width: "100%" }} component="div" variant="outlined">
                                    <TopFlagTable flags={companyInfo.riskFlags} title={"Risk Factors"} />
                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid size={12}>
                        <Divider />
                    </Grid>
                    <Grid size={12}>
                        <Grid container spacing={1}>
                            <Grid size={{ md: 12, lg: 6 }}>
                                {/* <Paper variant="outlined">
                                    <DispositionTable dispositionCount={companyInfo.sessionStats} />
                                </Paper> */}
                                <Paper variant="outlined">
                                    <ImportantQuestionTable questionStats={companyInfo.sessionStats} />
                                </Paper>
                            </Grid>
                            <Grid size={{ md: 12, lg: 6 }}>
                                <Paper variant="outlined">
                                    <CompanyActionHistoryTable historyCount={companyInfo.companyActionHistory} />
                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid size={12}>
                        <Divider />
                    </Grid>
                    {/* <Grid size={12}>
                        <Grid container spacing={1}>
                            <Grid size={{ md: 12, lg: 6 }}>
                                <Paper variant="outlined">
                                    <ImportantQuestionTable questionStats={companyInfo.sessionStats} />
                                </Paper>
                            </Grid>
                            {/*TODO: EVENTUALLY FILL IN WITH OTHER QUESTIONS/DATA TBD ON WHAT  */}
                    {/* <Grid size={{ md: 12, lg: 6 }}>
                                <Paper variant="outlined">
                                    <ImportantQuestionTable questionStats={companyInfo.sessionStats} />
                                </Paper>
                            </Grid> 
                        </Grid>
                    </Grid> */}
                    <Grid size={12}>
                        <Grid container spacing={1}>
                            {/* Coming Soon wrapper */}
                            <Grid size={12}>
                                <Box
                                    sx={{
                                        position: "relative", // for overlay
                                    }}
                                >
                                    {/* Dimmed inner content */}
                                    <Paper
                                        sx={{
                                            width: "100%",
                                            padding: ".5rem",
                                            // opacity: 0.4,          // gray out
                                            // pointerEvents: "none", // disable interaction
                                        }}
                                        component="div"
                                        variant="outlined"
                                    >
                                        <CommonThemes />
                                    </Paper>

                                    {/* Overlay label */}
                                    {/* <Box
                                        sx={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "100%",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            // pointerEvents: "none",
                                        }}
                                    >
                                        <Typography variant="h6" color="text.secondary">
                                            Coming Soon
                                        </Typography>
                                    </Box> */}
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid size={12}>
                        <Grid container spacing={1}>
                            <Grid size={{ md: 12, lg: 6 }}>
                                <Paper data-tour="anxiety-markers" sx={{ width: "100%" }} component="div" variant="outlined">
                                    <AgeMarkerGraph data={companyInfo.companyStudentAgeFlags} maxYValue={16} title="Student Age vs Anxiety Marker Average" filter="anxiety" />
                                </Paper>
                            </Grid>
                            <Grid size={{ md: 12, lg: 6 }}>
                                <Paper data-tour="depression-markers" sx={{ width: "100%" }} component="div" variant="outlined">
                                    <AgeMarkerGraph data={companyInfo.companyStudentAgeFlags} maxYValue={15} title="Student Age vs Depression Marker Average" filter="depression" />
                                    {/* <Typography>Graph x axis age, y axis depression</Typography> */}
                                </Paper>
                            </Grid>

                        </Grid>
                    </Grid>

                </Grid>
            </Card>
        </LoadingWrapper >
    )
}

export default CompanyStudentStats